// firebase.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyC99rh3xwVoc0oJ23nHjIcwXdUBxfZhkNs",
  authDomain: "trump2-acea5.firebaseapp.com",
  databaseURL: "https://trump2-acea5-default-rtdb.europe-west1.firebasedatabase.app/",
  projectId: "trump2-acea5",
  storageBucket: "trump2-acea5.firebasestorage.app",
  messagingSenderId: "65380003652",
  appId: "1:65380003652:web:589d55a0a57ff2809c3111",
  measurementId: "G-3Y4CTQ7H3T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export { database };